/**
 * about.tsx
 * 
 * @copyright jnakaso.com
 * 
 * About page will contain
 * <li>About</li>
 * <li>Contacts</li>
 * 
 */

import { Stack } from "@mantine/core";
import InfoFile from "src/components/info-file";


function Info() {

    return (
        <Stack>
            <InfoFile title="Recent Minutes" file="minutes.md" />
        </Stack>
    );

}

export default Info;